import { canEnableSwiperLoop } from './utils';

export default () => ({
    swiper: null,
    init() {
        this.checkBreakpoint();
    },
    enable() {
        const breakpoints = {
            300: {
                slidesPerView: 1.5,
                pagination: false,
                direction: 'horizontal',
                spaceBetween: 7.5,
            },
        };

        this.swiper = new Swiper(this.$refs.aboutImagesCarousel, {
            slidesPerView: 1.5,
            spaceBetween: 15,
            loop: canEnableSwiperLoop(this.$refs.aboutImagesCarousel, { slidesPerView: 1.5, breakpoints }),
            breakpoints,
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
        });
    },

    checkBreakpoint() {
        const mediaQuery = '(max-width: 768px)';
        const mediaQueryList = window.matchMedia(mediaQuery);

        if (mediaQueryList.matches) {
            this.enable();
        } else {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
        }

        mediaQueryList.addEventListener('change', event => {
            if (event.matches) {
                this.enable();
            } else {
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                }
            }
        });
    },
});
